module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details purchase"
  }, [_c('navbar'), _vm._v(" "), _c('steps', {
    attrs: {
      "current": _vm.current
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "succeeds"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/succeeds_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('user_order_pay_success')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Ongoing'
      }
    }
  }, [_c('p', {
    staticClass: "learn_order",
    staticStyle: {
      "color": "#0084FF",
      "font-size": "16px",
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('order_details')) + " >")])])], 1), _vm._v(" "), _c('listing', {
    attrs: {
      "lists": _vm.order_detail
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "order-payment details-width"
  }, [_c('guess')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76b765d6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyDetails/PurchaseSucceeds.vue
// module id = 830
// module chunks = 0